import { useSelector } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';
import { Path } from 'constants/routes';
import { Ellipsis } from 'utils/healper';

export const useHyperTestProjectName = () => {
  const CHAR_LIMIT = 32;
  const location = useLocation();
  const [searchParams] = useSearchParams();
  let jobId = searchParams.get('jobId');

  const base64Data = searchParams.get('details');
  let projectNameFromURL = null;
  let projectIdFromURL = null;
  let jobNumberFromURL = null;
  if (base64Data) {
    const jsonString = atob(decodeURIComponent(base64Data));
    const data = JSON.parse(jsonString);
    jobId = data.jobId;
    projectNameFromURL = decodeURIComponent(data.projectName);
    projectIdFromURL = data.projectId;
    jobNumberFromURL = data.jobNumber;
  }




  let projectNameData = {
    showProjectName: false,
    fullProjectName: null,
    truncatedProjectName: null,
    exceedsCharLimit: false,
    projectId: null,
  };

  const job = useSelector(
    (state) => state.hypertestJobDetail?.hypertestJobDetail?.data?.data
  );

  let isTaskPath = location.pathname === Path.TASK && jobId;
  if (['/test', '/share'].includes(location.pathname) && jobId) {
    isTaskPath = true;
  }

  if (isTaskPath) {
    const projectName = job?.project?.name || projectNameFromURL;
    const projectId = job?.project?.id || projectIdFromURL;

    if (projectName && typeof projectName === 'string' && projectName.trim()) {
      const exceedsCharLimit = projectName.length >= CHAR_LIMIT;
      const truncatedProjectName = Ellipsis(projectName, CHAR_LIMIT);
      projectNameData = {
        showProjectName: true,
        fullProjectName: projectName,
        truncatedProjectName: truncatedProjectName,
        exceedsCharLimit: exceedsCharLimit,
        projectId: projectId,
        jobNumber: jobNumberFromURL,
        jobId: jobId,
      };
    }
  }

  return projectNameData;
};
